// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","App-logo":"App_App-logo__yMrik","MouseTrail":"App_MouseTrail__iRm3D","body":"App_body__PuluK"};